import React from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import BackNavigation from 'srcReact/components/common2/BackNavigation'
import { redirectToBack } from 'srcReact/helpers/history'
import { useSelector } from 'react-redux'

const MobileHeader = ({ activeItem, setActiveItem }) => {
  const { t } = useTranslation()

  const {
    common: { isNative }
  } = useSelector((state) => state)

  const handleBackButton = () => {
    if (activeItem === t('organizationSettings.title')) {
      redirectToBack(isNative)
    }
    setActiveItem(t('organizationSettings.title'))
  }

  return (
    <div className={styles.mobileHeaderWrapper}>
      <BackNavigation theme='white' className={styles.back} customHandleBack={handleBackButton} />
      <h1 className={styles.heading}>{activeItem}</h1>
    </div>
  )
}

export default MobileHeader
